let moneyFormat = window.theme.moneyFormat;;

function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(0);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function comparison() { 
  return {
    productData: [],
    firstProductParams: [],

    compareProd: [],
    show: false,
    getProductBy(attr, index) {
      let id = this.productData[index]
      let prodData = window.comparisonProducts[id]
      let prod = prodData['product']
      let result = ''
      if (['price', 'compare_at_price'].includes(attr)) {
        let price = formatMoney(prod[attr], moneyFormat);
        if (attr == 'compare_at_price' && !prod[attr]) {
          price = 0
        }
        result = price
      } else if (['short_description', 'product_image'].includes(attr)) {
        result = prodData[attr]
      } else if (prod[attr]) {
        result = prod[attr]
      }

      return result
    },
    getProductItem() {
      const firstProductId = this.productData[0]
      let prodData = window.comparisonProducts[firstProductId]['comparison'];
      let prodDataJson = {}
      if (prodData) {
        prodDataJson = prodData;
      }

      window.prodDataJson1 = prodDataJson
      let result = []
      for (const key in prodDataJson) {
        result.push({
          code: '',
          title: key,
          is_orange: false,
          level: 1
        })
        let i = 0
        for (const key1 in prodDataJson[key]) {
          i++;
          let title = prodDataJson[key][key1]['title'];

          result.push({
            code: key1,
            i: i,
            len: Object.values(prodDataJson[key]).length,
            parent_code: key,
            title: title,
            is_orange: prodDataJson[key][key1]['is_orange'],
            level: 2
          })
          // if (title != '/') {
          //   result.push({
          //     code: key1,
          //     i: i,
          //     len: Object.values(prodDataJson[key]).filter((item) => item.title != '/').length,
          //     parent_code: key,
          //     title: title,
          //     is_orange: prodDataJson[key][key1]['is_orange'],
          //     level: 2
          //   })
          // }
        }
      }
      // 第一列
      this.firstProductParams = result
      
      this.renderCompareItem()
      setTimeout(() => {
        document.querySelectorAll('[data-first=item]').forEach((item, i) => {
          let code = item.getAttribute('data-code')
          let res = result.find(item => item.code == code)
        
          if (res) {
            if (res.is_orange) {
              item.style.color = '#D95E00'
            } else {
              item.style.color = 'rgba(0,0,0,0.65)'
            }
          }
        })
      }, 600)
    },
    renderCompareItem() {
      setTimeout(() => {
        document.querySelectorAll('[data-compare=compare-item]').forEach(item => {
          const productId = item.getAttribute('data-id')
          const parent_code = item.getAttribute('data-parent-code')
          const code = item.getAttribute('data-code')
          let prodData = window.comparisonProducts[productId]['comparison'];
          if (prodData) {
            const prodDataJson = prodData;
            if (prodDataJson[parent_code] && prodDataJson[parent_code][code])  {
              item.innerHTML = prodDataJson[parent_code][code].title
              if (prodDataJson[parent_code][code].is_orange) {
                item.style.color = '#D95E00'
              } else {
                item.style.color = 'rgba(0,0,0,0.65)'
              }
            } else {
              item.innerHTML = '/'
              item.removeAttribute('style')
            }
          } else {
            item.innerHTML = '/'
            item.removeAttribute('style')
          }
        })
        this.show = true
      }, 600)
    },
    getCompareItem(item, index) {
      const productId = this.productData[index]
      const parent_code = item.parent_code
      const code = item.code
      let result = {
        title: '',
        is_orange: false
      }
      let prodData = window.comparisonProducts[productId]['comparison'];
      if (prodData) {
        const prodDataJson = JSON.parse(prodData);
        if (prodDataJson[parent_code] && prodDataJson[parent_code][code])  {
          result = {
            title: prodDataJson[parent_code][code]['title'],
            is_orange: prodDataJson[parent_code][code]['is_orange']
          }
        } else {
          result = {
            title: '',
            is_orange: false
          }
        }
      } else {
        result = {
          title: '',
          is_orange: false
        }
      }

      return result
    },
    init() {
      let self = this

      document.querySelectorAll('.comparison-hd custom-select').forEach(function(el) {
        el.addEventListener('change', function(e) {
          let ids = []
          self.show = false
          document.querySelectorAll('[data-pdp-section=comparison] input[type=hidden]').forEach(function(item) { 
            ids.push(item.value)
          })

          self.productData = ids
          self.compareProd = Array(ids.length - 1).fill('')
          self.getProductItem()

          let elem = document.querySelector('.comparison-2');
          if (elem.classList.contains('hidden')) {
            document.querySelector('.comparison-1').classList.add('hidden');
            elem.classList.remove('hidden');
          }
        })
      })

      const sentinel = document.querySelector('.sentinel');
      const stickyEl = document.querySelector('.comparison-hd');

      if (sentinel) {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.boundingClientRect.y < 0 && !entry.isIntersecting) {
              console.log('🟡 粘附中');

              stickyEl.classList.add('active')
            } else {
              if (stickyEl.classList.contains('active')) {
                stickyEl.classList.remove('active')
              }
              console.log('⚪ 没有粘附');
            }
          });
        }, {
          root: null,
          threshold: [0],
        });
  
        observer.observe(sentinel);
      }
    },
  };
}
